module.exports = __webpack_public_path__ + "img/PR.9f01bc0c.svg";